<template>
  <div>
    <page v-for="(chunk, pageIndex) in chunked_rooms" :key="pageIndex" size="A4" class="page">
      <div v-for="(bill, index) in chunk" :key="index" class="col-6">
        <table class="mx-auto room-bill">
          <tr style="height: 38px">
            <td
              colspan="2"
              class="text-left text-no-wrap font-weight-bold"
              style="width: 200px"
            >
              Tháng {{ bill.month | toLocaleMonth }}
            </td>
          </tr>
          <tr>
            <td
              class="text-left text-no-wrap font-weight-bold"
              style="width: 200px;"
            >
              {{ bill.name }}
            </td>
            <td
              class="text-right text-no-wrap font-weight-bold"
              style="width: 200px"
            >
              {{ bill.room_id }}
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">Số ngày</td>
            <td class="text-right">{{ bill.date_count | formatNumber }}</td>
          </tr>
          <tr>
            <td class="font-weight-bold">Tiền phòng {{ bill.roomTerm }}</td>
            <td class="text-right">
              {{ bill.room_bill | formatNumber }}
            </td>
          </tr>

          <tr>
            <td class="font-weight-bold" colspan="2">
              Tiền dịch vụ ({{ bill.serviceTermStartDate }} - {{ bill.serviceTermEndDate }})
            </td>
          </tr>
          <tr>
            <td class="text-left text-no-wrap" style="width: 300px">
              -- Tiền rác và vệ sinh
            </td>
            <td class="text-right text-no-wrap">
              {{ bill.trash_bill | formatNumber }}
            </td>
          </tr>
          <tr>
            <td class="text-left text-no-wrap">
              -- Tiền Internet
            </td>
            <td class="text-right text-no-wrap">
              {{ bill.internet.total_bill | formatNumber }}
            </td>
          </tr>
          <tr>
            <td class="text-left text-no-wrap">
              -- Tiền xe
            </td>
            <td class="text-right text-no-wrap">
              {{
                (bill.motorbike.total_bill + bill.bike.total_bill)
                  | formatNumber
              }}
            </td>
          </tr>
          <tr>
            <td class="text-left text-no-wrap">
              -- Tiền máy giặt
            </td>
            <td class="text-right text-no-wrap">
              {{ bill.washing_machine.total_bill | formatNumber }}
            </td>
          </tr>
          <tr>
            <td class="text-left text-no-wrap">
              -- Tiền máy lạnh
            </td>
            <td class="text-right text-no-wrap">
              {{ bill.air_conditioner.total_bill | formatNumber }}
            </td>
          </tr>
          <tr class="font-weight-bold">
            <td class="text-left text-no-wrap">Thành tiền</td>
            <td class="text-right text-no-wrap">
              {{
                (bill.trash_bill +
                  bill.internet.total_bill +
                  bill.motorbike.total_bill +
                  bill.bike.total_bill +
                  bill.washing_machine.total_bill +
                  bill.air_conditioner.total_bill)
                  | formatNumber
              }}
            </td>
          </tr>

          <tr>
            <td class="font-weight-bold" colspan="2">Tiền điện</td>
          </tr>
          <tr>
            <td class="text-left text-no-wrap">Đơn giá</td>
            <td class="text-right text-no-wrap">
              {{ bill.electric_price | formatNumber }}
            </td>
          </tr>
          <tr>
            <td class="text-left text-no-wrap">
              -- Đầu kỳ ({{ bill.electricTermStartDate }})
            </td>
            <td class="text-right text-no-wrap" v-if="bill.electric_meter_change">
              {{ bill.electric.start }} / {{ bill.electric_meter_change.new_meter_number | formatNumber }}
            </td>
            <td class="text-right text-no-wrap" v-else>
              {{ bill.electric.start | formatNumber }}
            </td>
          </tr>
          <tr>
            <td class="text-left text-no-wrap">
              -- Cuối kỳ ({{ bill.electricTermEndDate }})
            </td>
            <td class="text-right text-no-wrap" v-if="bill.electric_meter_change">
              {{ bill.electric_meter_change.old_meter_number }} / {{ bill.electric.end | formatNumber }}
            </td>
            <td class="text-right text-no-wrap" v-else>
              {{ bill.electric.end | formatNumber }}
            </td>
          </tr>
          <tr>
            <td class="text-left text-no-wrap">-- Tiêu thụ</td>
            <td class="text-right text-no-wrap" v-if="bill.electric_meter_change">
              {{ (bill.electric.end - bill.electric_meter_change.new_meter_number + bill.electric_meter_change.old_meter_number - bill.electric.start) | formatNumber }}
            </td>
            <td class="text-right text-no-wrap" v-else>
              {{ (bill.electric.end - bill.electric.start) | formatNumber }}
            </td>
          </tr>
          <tr class="font-weight-bold">
            <td class="text-left text-no-wrap">Thành tiền</td>
            <td class="text-right text-no-wrap">
              {{ bill.electric.total_bill | formatNumber }}
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold" colspan="2">
              Tiền nước
            </td>
          </tr>
          <tr>
            <td class="text-left text-no-wrap">Đơn giá</td>
            <td class="text-right text-no-wrap">
              {{ bill.water_price | formatNumber }}
            </td>
          </tr>
          <tr>
            <td class="text-left text-no-wrap">
              -- Đầu kỳ ({{ bill.waterTermStartDate }})
            </td>
            <td class="text-right text-no-wrap" v-if="bill.water_meter_change">
              {{ bill.water.start }} / {{ bill.water_meter_change.new_meter_number | formatNumber }}
            </td>
            <td class="text-right text-no-wrap" v-else>
              {{ bill.water.start | formatNumber }}
            </td>
          </tr>
          <tr>
            <td class="text-left text-no-wrap">
              -- Cuối kỳ ({{ bill.waterTermEndDate }})
            </td>
            <td class="text-right text-no-wrap" v-if="bill.water_meter_change">
              {{ bill.water_meter_change.old_meter_number }} / {{ bill.water.end | formatNumber }}
            </td>
            <td class="text-right text-no-wrap" v-else>
              {{ bill.water.end | formatNumber }}
            </td>
          </tr>
          <tr>
            <td class="text-left text-no-wrap">-- Tiêu thụ</td>
            <td class="text-right text-no-wrap" v-if="bill.water_meter_change">
              {{ (bill.water.end - bill.water_meter_change.new_meter_number + bill.water_meter_change.old_meter_number - bill.water.start) | formatNumber }}
            </td>
            <td class="text-right text-no-wrap" v-else>
              {{ (bill.water.end - bill.water.start) | formatNumber }}
            </td>
          </tr>
          <tr class="font-weight-bold">
            <td class="text-left text-no-wrap">Thành tiền</td>
            <td class="text-right text-no-wrap">
              {{ bill.water.total_bill | formatNumber }}
            </td>
          </tr>

          <tr style="height: 10px">
            <td colspan="2">
            </td>
          </tr>
          <tr class="font-weight-bold">
            <td class="text-left">TỔNG CỘNG</td>
            <td class="text-right">
              {{ bill.total_bill | formatNumber }}
            </td>
          </tr>
          <tr class="font-weight-bold" >
            <td class="text-left" style="width: 350px">Số tiền nộp thiếu/dư tháng trước</td>
            <td class="text-right">
              {{ bill.previousMonthDebt | formatNumber }}
            </td>
          </tr>
          <tr class="font-weight-bold">
            <td class="text-left">TỔNG CỘNG SỐ TIỀN PHẢI NỘP</td>
            <td class="text-right">
              {{ bill.totalBillWithDebt | formatNumber }}
            </td>
          </tr>
          <tr style="height: 38px">
            <td class="font-weight-bold" colspan="2">
              Gọi 0835990179 gặp Hương để phản ánh
            </td>
          </tr>
        </table>
      </div>
    </page>
  </div>
</template>

<script>
import { deepCopy } from "Helpers";
import { handleDateCount } from "@/functions";
import moment from "moment";

export default {
  name: "print-room-bill",
  props: {
    room_data: {
      type: Array,
      default: [],
    },
    previous_month_room_data: {
      type: Array,
      default: [],
    },
    chosen_month: String,
  },
  data() {
    return {};
  },
  computed: {
    chunked_rooms() {
      const rooms = this.computed_room_sorted;
      const chunks = [];
      for (let i = 0; i < rooms.length; i += 4) {
        chunks.push(rooms.slice(i, i + 4));
      }
      return chunks;
    },
    computed_room_sorted() {
      const virtual_room_data = deepCopy(this.room_data);
      const gb = virtual_room_data.filter((room) => room.building === "GB");
      const tt = virtual_room_data.filter((room) => room.building === "TT");
      const mt = virtual_room_data.filter((room) => room.building === "MT");
      const bn = virtual_room_data.filter((room) => room.building === "BN");
      const a = virtual_room_data.filter((room) => {
        const last_char = room.room_id[room.room_id.length - 1];
        return room.building != "MA" && last_char == "A";
      });
      const b = virtual_room_data.filter((room) => {
        const last_char = room.room_id[room.room_id.length - 1];
        return room.building != "GB" && last_char == "B";
      });
      const ma = this.room_data.filter((room) => room.building === "MA");
      // return [gb, tt, mt, bn, a, b, ma]
      return gb
        .concat(tt)
        .concat(mt)
        .concat(bn)
        .concat(a)
        .concat(b)
        .concat(ma)
        .map((bill) => {
          const firstDateOfInputMonth = new Date(bill.month + "-01");

          // Get next month
          const firstDateOfNextMonth = moment(firstDateOfInputMonth)
            .add(1, "months")
            .toISOString();
          const nextMonth = new Date(firstDateOfNextMonth)
            .toLocaleDateString("en-GB")
            .substr(3);

          // Get last month
          const firstDateOfLastMonth = new Date(
            moment(firstDateOfInputMonth)
              .subtract(1, "months")
              .toISOString()
          );
          const lastMonth = new Date(firstDateOfLastMonth)
            .toLocaleDateString("en-GB")
            .substr(3);

          const lastDateOfInputMonth = moment(firstDateOfInputMonth)
            .add(1, "months")
            .subtract(1, "day")
            .toISOString();

          const electricTermStartDate = new Date(firstDateOfInputMonth)
            .toLocaleDateString("en-GB")
            .substr(0, 5);
          const electricTermEndDate = new Date(lastDateOfInputMonth)
            .toLocaleDateString("en-GB")
            .substr(0, 5);

          const waterTermStartDate = new Date(firstDateOfLastMonth);
          if (bill.month === "2025-03") {
            waterTermStartDate.setDate(5);
          } else {
            waterTermStartDate.setDate(12);
          }
          const waterTermEndDate = new Date(bill.month + "-11")
            .toLocaleDateString("en-GB")
            .substr(0, 5);
          let serviceTermStartDate;
          if (bill.date_count < 30) {
            serviceTermStartDate = new Date(bill.date_in);
          } else {
            serviceTermStartDate = new Date(bill.month + "-01");
          }
          const serviceTermEndDate = new Date(lastDateOfInputMonth)
            .toLocaleDateString("en-GB")
            .substr(0, 5);

          const previous_month_bill = this.previous_month_room_data.find(
            (e) => e.room_id === bill.room_id
          );

          let previousMonthDebt = 0;

          if (previous_month_bill) {
            previousMonthDebt =
              previous_month_bill.total_bill -
              previous_month_bill.collected_amount;
          }

          const totalBillWithDebt = bill.total_bill + previousMonthDebt;

          const lastDateOfInputMonthDate = moment(firstDateOfInputMonth)
            .add(1, "months")
            .subtract(1, "day")
            .toDate();

          // Use date_out if available, otherwise use handleDateCount to determine full month stay
          let staysUntilEndOfMonth = false;
          if (bill.date_out) {
            const stayEndDate = new Date(bill.date_out);
            staysUntilEndOfMonth = moment(stayEndDate).isSame(lastDateOfInputMonthDate, 'day') ||
              moment(stayEndDate).isAfter(lastDateOfInputMonthDate, 'day');
          } else {
            // Use handleDateCount to recalculate and compare - same logic as RoomBillDetail.vue
            const recalculatedDateCount = handleDateCount({
              date_start: bill.date_in,
              chosen_month: bill.month,
              date_end: lastDateOfInputMonthDate,
            });
            staysUntilEndOfMonth = recalculatedDateCount === bill.date_count;
          }

          let roomTerm;
          if (staysUntilEndOfMonth) {
            // Show next month format
            roomTerm = `(tháng ${nextMonth})`;
          } else {
            // Show date range format using serviceTermStartDate and serviceTermEndDate
            const serviceTermStartDateStr = new Date(serviceTermStartDate)
              .toLocaleDateString("en-GB")
              .substr(0, 5);
            roomTerm = `(${serviceTermStartDateStr} - ${serviceTermEndDate})`;
          }

          return {
            ...bill,
            nextMonth,
            lastMonth,
            electricTermStartDate,
            electricTermEndDate,
            waterTermStartDate: waterTermStartDate
              .toLocaleDateString("en-GB")
              .substr(0, 5),
            waterTermEndDate,
            serviceTermStartDate: new Date(serviceTermStartDate)
              .toLocaleDateString("en-GB")
              .substr(0, 5),
            serviceTermEndDate,
            previousMonthDebt,
            totalBillWithDebt,
            roomTerm,
          };
        });
    },
  },
};
</script>

<style scoped>
.col-6 {
  float: left;
  width: 50%;
}
body {
  background: rgb(204, 204, 204);
}
page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}
page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
page[size="A4"][layout="landscape"] {
  width: 29.7cm;
  height: 21cm;
}
page[size="A3"] {
  width: 29.7cm;
  height: 42cm;
}
page[size="A3"][layout="landscape"] {
  width: 42cm;
  height: 29.7cm;
}
page[size="A5"] {
  width: 14.8cm;
  height: 21cm;
}
page[size="A5"][layout="landscape"] {
  width: 21cm;
  height: 14.8cm;
}
@media print {
  body,
  page {
    margin: 0;
    box-shadow: 0;
  }
}
</style>
